// eslint-disable-next-line no-restricted-imports
import i18next from 'i18next';
import HttpBackend from 'i18next-http-backend';
import { TranslationNamespaces, ColonistI18n, I18n } from '@colonist/i18n';
import { initTranslation } from './ui_utils/DomUtils.ts';
import { UIUtilsEjsVariables } from './UIUtilsEjsVariables.ts';
import { ClientUserState } from './ClientUserState.ts';
import { StorageWrapper } from './StorageWrapper.ts';
/* eslint-disable boundaries/dependencies */ import StringsAF from '../../../../packages/i18n/src/locales/af/strings.json';
import StringsAR from '../../../../packages/i18n/src/locales/ar/strings.json';
import StringsCA from '../../../../packages/i18n/src/locales/ca/strings.json';
import StringsCS from '../../../../packages/i18n/src/locales/cs/strings.json';
import StringsDA from '../../../../packages/i18n/src/locales/da/strings.json';
import StringsDE from '../../../../packages/i18n/src/locales/de/strings.json';
import StringsEL from '../../../../packages/i18n/src/locales/el/strings.json';
import StringsEN from '../../../../packages/i18n/src/locales/en/strings.json';
import StringsES from '../../../../packages/i18n/src/locales/es/strings.json';
import StringsFI from '../../../../packages/i18n/src/locales/fi/strings.json';
import StringsFR from '../../../../packages/i18n/src/locales/fr/strings.json';
import StringsHE from '../../../../packages/i18n/src/locales/he/strings.json';
import StringsHI from '../../../../packages/i18n/src/locales/hi/strings.json';
import StringsHU from '../../../../packages/i18n/src/locales/hu/strings.json';
import StringsIT from '../../../../packages/i18n/src/locales/it/strings.json';
import StringsJA from '../../../../packages/i18n/src/locales/ja/strings.json';
import StringsKO from '../../../../packages/i18n/src/locales/ko/strings.json';
import StringsNL from '../../../../packages/i18n/src/locales/nl/strings.json';
import StringsNO from '../../../../packages/i18n/src/locales/no/strings.json';
import StringsPL from '../../../../packages/i18n/src/locales/pl/strings.json';
import StringsPTBR from '../../../../packages/i18n/src/locales/pt-BR/strings.json';
import StringsPTPT from '../../../../packages/i18n/src/locales/pt-PT/strings.json';
import StringsRO from '../../../../packages/i18n/src/locales/ro/strings.json';
import StringsRU from '../../../../packages/i18n/src/locales/ru/strings.json';
import StringsSR from '../../../../packages/i18n/src/locales/sr/strings.json';
import StringsSV from '../../../../packages/i18n/src/locales/sv/strings.json';
import StringsTH from '../../../../packages/i18n/src/locales/th/strings.json';
import StringsTR from '../../../../packages/i18n/src/locales/tr/strings.json';
import StringsUK from '../../../../packages/i18n/src/locales/uk/strings.json';
import StringsVI from '../../../../packages/i18n/src/locales/vi/strings.json';
import StringsZHCN from '../../../../packages/i18n/src/locales/zh-CN/strings.json';
import StringsZHTW from '../../../../packages/i18n/src/locales/zh-TW/strings.json';
import { initDeviceLanguage } from './ui_utils/DeviceLanguageUtils.ts';
/* eslint-enable boundaries/dependencies */ const languageFileURLs = {
    strings: {
        /* eslint-disable @typescript-eslint/naming-convention */ af: StringsAF,
        ar: StringsAR,
        ca: StringsCA,
        cs: StringsCS,
        da: StringsDA,
        de: StringsDE,
        el: StringsEL,
        en: StringsEN,
        es: StringsES,
        fi: StringsFI,
        fr: StringsFR,
        he: StringsHE,
        hi: StringsHI,
        hu: StringsHU,
        it: StringsIT,
        ja: StringsJA,
        ko: StringsKO,
        nl: StringsNL,
        no: StringsNO,
        pl: StringsPL,
        'pt-BR': StringsPTBR,
        'pt-PT': StringsPTPT,
        ro: StringsRO,
        ru: StringsRU,
        sr: StringsSR,
        sv: StringsSV,
        th: StringsTH,
        tr: StringsTR,
        uk: StringsUK,
        vi: StringsVI,
        'zh-CN': StringsZHCN,
        'zh-TW': StringsZHTW
    }
};
(function(ClientI18nInitiation) {
    const i18n = i18next;
    async function init() {
        initDeviceLanguage();
        initTranslation((key, options)=>clientI18n.t(key, options));
        await i18n.use(HttpBackend).init({
            lng: UIUtilsEjsVariables.language,
            fallbackLng: I18n.defaultLanguage,
            ns: TranslationNamespaces.Strings,
            backend: {
                loadPath: (lng, ns)=>languageFileURLs[ns][lng]
            },
            defaultNS: TranslationNamespaces.Strings,
            interpolation: {
                skipOnVariables: false
            }
        });
        ClientUserState.registerChangeListener((userState)=>{
            if (userState == undefined) return;
            if (ClientUserState.isStale()) return;
            const userLanguage = userState.language;
            if (userLanguage == undefined) return;
            if (StorageWrapper.getLanguage() != userLanguage) {
                StorageWrapper.setLanguage(userLanguage);
                StorageWrapper.setLanguagePreferenceSelected(true);
            }
            if (UIUtilsEjsVariables.language == userLanguage) return;
            if (UIUtilsEjsVariables.language != I18n.defaultLanguage) return;
            window.location.pathname = replaceLanguageInPath(window.location.pathname, userLanguage);
        });
    }
    ClientI18nInitiation.init = init;
})(ClientI18nInitiation || (ClientI18nInitiation = {}));
export const clientI18n = new ColonistI18n(i18next);
export class IntlColonistWrapper {
    getLanguageName(code, overrideLocale) {
        const locale = overrideLocale !== null && overrideLocale !== void 0 ? overrideLocale : this.defaultLocale;
        try {
            return new Intl.DisplayNames(locale, {
                type: 'language'
            }).of(code);
        } catch (e) {
            return I18n.languageEnglishNames[code];
        }
    }
    getCountryName(countryCode, overrideLocale) {
        const locale = overrideLocale !== null && overrideLocale !== void 0 ? overrideLocale : this.defaultLocale;
        try {
            return new Intl.DisplayNames(locale, {
                type: 'region'
            }).of(countryCode);
        } catch (e) {
            return undefined;
        }
    }
    getLanguagePathPrefix() {
        return this.defaultLocale === I18n.defaultLanguage ? '' : `/${this.defaultLocale}`;
    }
    constructor(locale){
        this.defaultLocale = locale;
    }
}
export const clientIntl = new IntlColonistWrapper(UIUtilsEjsVariables.language);
export function replaceLanguageInPath(path, newLanguage) {
    var _pathParts_;
    const pathParts = path.split('/');
    const newPathParts = [];
    if (pathParts[0] == '') {
        var _pathParts_shift;
        newPathParts.push((_pathParts_shift = pathParts.shift()) !== null && _pathParts_shift !== void 0 ? _pathParts_shift : '');
    }
    if (pathParts[0] == '.proxy') {
        var _pathParts_shift1;
        newPathParts.push((_pathParts_shift1 = pathParts.shift()) !== null && _pathParts_shift1 !== void 0 ? _pathParts_shift1 : '');
    }
    if ((_pathParts_ = pathParts[0]) === null || _pathParts_ === void 0 ? void 0 : _pathParts_.match(/^[a-z]{2}(-[a-z]{2})?$/i)) {
        pathParts.shift() // remove current language
        ;
    }
    if (newLanguage != I18n.defaultLanguage) newPathParts.push(newLanguage);
    newPathParts.push(...pathParts);
    if (newPathParts[newPathParts.length - 1] == '') {
        newPathParts.pop() // create language urls that are the same as the canonical url. /ca, not /ca/
        ;
    }
    return newPathParts.join('/');
}
export var ClientI18nInitiation;
